import { MenuItem, TextField } from '@material-ui/core';
import opcoesArredondamento from 'utils/opcoesArredondamento';
import { TipoArredondamento } from 'utils/TipoArredondamento';
import { iPropostaDados } from '../..';

interface ISelecaoArredondamento {
  informacaoProposta: iPropostaDados;
  isModoSimulacao: boolean;
  onChange: (a: iPropostaDados) => void;
  isLoading?: boolean;
}

export default function SelecaoArredondamento({
  informacaoProposta,
  isModoSimulacao,
  onChange,
  isLoading = false,
}: ISelecaoArredondamento): JSX.Element {
  return (
    <>
      <TextField
        select
        label="Regra de arredondamento"
        variant="outlined"
        size="small"
        fullWidth
        // style={{ width: 260 }}
        helperText="Define como cada equipamento será arredondado."
        disabled={!isModoSimulacao || isLoading}
        value={informacaoProposta.outros?.tipoArredondamento}
        onChange={e =>
          onChange({
            ...informacaoProposta,
            outros: {
              ...informacaoProposta.outros,
              tipoArredondamento: e.target.value as TipoArredondamento,
              isRegramentoGeral:
                informacaoProposta.outros?.isRegramentoGeral ?? false,
              isParcelamentoEspecial:
                informacaoProposta.outros?.isParcelamentoEspecial ?? false,
            },
          })
        }
        SelectProps={{
          MenuProps: {
            getContentAnchorEl: null,
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
            transformOrigin: {
              vertical: 'top',
              horizontal: 'left',
            },
          },
        }}
      >
        {opcoesArredondamento.map(opcao => (
          <MenuItem key={opcao.valor} value={opcao.valor}>
            {opcao.descricao}
          </MenuItem>
        ))}
      </TextField>
    </>
  );
}
